import * as Constants from '../constants';
import { default as Endpoint } from '../../api/Endpoint';

export function requestFlags() {
  return {
    type: Constants.REQUEST_FLAGS
  };
}

export function receiveFlags(json, error) {
  return {
    type: Constants.RECEIVE_FLAGS,
    data: json,
    error
  };
}

export function getFlags(options = {}) {
  const path = 'ecs/api/flags';
  return new Endpoint(path, requestFlags, receiveFlags)
    .withMethod('GET')
    .withOptions(options)
    .call();
}
